import { render, staticRenderFns } from "./SessionOutcomes.vue?vue&type=template&id=b241d9a4&"
import script from "./SessionOutcomes.vue?vue&type=script&lang=ts&"
export * from "./SessionOutcomes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports